export const MAX_STORES = 16
export const ELIGIBLE_CITIES = [
  "amsterdam",
  "athens",
  "bangkok",
  "barcelona",
  "berlin",
  "buenos-aires",
  "chicago",
  "edinburgh",
  "florence",
  "lisbon",
  "london",
  "los-angeles",
  "madrid",
  "melbourne",
  "mexico-city",
  "miami",
  "milan",
  "naples",
  "new-orleans",
  "new-york",
  "nice",
  "osaka",
  "paris",
  "porto",
  "prague",
  "rome",
  "san-diego",
  "san-francisco",
  "sao-paulo",
  "seoul",
  "singapore",
  "sydney",
  "tokyo",
  "toronto",
  "valencia",
  "vancouver",
  "venice",
  "vienna",
]
